import React, { useReducer, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Modal from "react-bootstrap/Modal";
import "../../styles/Modal.css";
const formReducer = (state, action) => {
  switch (action.type) {
    case "RESET_FORM":
      return initialState;
    case "TABLE_DATA":
      return {
        ...state,
        tableData: action.tableData,
      }
    default:
      return state;
  }
};
const initialState = {
  error: "",
  tableData: {}
};

const CustomDetailsComponent = (props) => {
  const [state, dispatch] = useReducer(formReducer, initialState);

  const {
    tableData,
  } = state;
  
  const handleClose = () => {
    setReadOnly(false);
    fileText && setFileText(null);
    dispatch({ type: "RESET_FORM" });
  };

  const { fileText, setFileText, gridEntries, readOnly, setReadOnly, requiredKeys, title } = props;

  useEffect(() => {
    if (fileText === undefined) {
      const filteredDate = Object.fromEntries(
        Object.entries(gridEntries)
        .filter(([key]) => requiredKeys.hasOwnProperty(key))
      )
      dispatch({ type: "TABLE_DATA", tableData: filteredDate});
    }
  }, [gridEntries]);

  let detailsDisplay =
  Object.entries(tableData).sort(([key1], [key2]) => 
    key2.localeCompare(key1))
    .map(([key, value]) => (
      <div style={{ color: "white" }} key={key}>
         <strong>{requiredKeys[key]}  :  </strong>{value !== null ? value : "No Data"}
      </div>
    ))

    const fileTextDisplay = 
        <div style={{ color: "white" }}>
           {fileText}
        </div>

  return (
      <Modal
        show={readOnly || fileText}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
          <Modal.Header className="cancelButton">
          <Modal.Title style={{ color: "#ffffff" }}>
            <Row>
            <Col sm={{ span: 12 }}>
              {title} 
            </Col>
            </Row>
            </Modal.Title>
          </Modal.Header>
        <Modal.Body style={{ background: "#212529" }}>
           <>
           <Row className="mb-3">
           <Col sm={16}>  
           {fileText === undefined  ? detailsDisplay : fileTextDisplay}
           </Col>
         </Row>
        <div className="py-2"></div>
          <Row className="mb-3">
            <Col sm={{ span: 8, offset: 4 }}>
            <Button
                  className="col-md-5"
                  size="sm"
                  variant="secondary"
                  onClick={handleClose}
                >
                  OK
              </Button>
            </Col>
          </Row>
          </>
        </Modal.Body>
      </Modal>
  );
};

export default CustomDetailsComponent;
